import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService, LandingService } from 'app/services';

export const landingGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const landingService = inject(LandingService);

    return combineLatest([landingService.getIsAllowed(), authService.me()]).pipe(
        map(([isAllowed, me]) => {
            if (isAllowed) return true;
            router.navigate(['/me', 'home']);
            return false;
        }),
    );
};
